// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1o1_f","header":"MessagesList_header__3x0qu","chat":"MessagesList_chat__1fAn9"};